import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
} from "@mui/material";
import moment from "moment";
import { fetchMyHomeworks } from "./redux/myHomeworksThunk";
import { fetchTeacherTimetable } from "../../TimeTable/redux/myTimetableSlice";
import { fetchSessionsThunk } from "../../../AcademicCalendar/redux/academicCalendarSlice";
import { getSyllabusThunk } from "../../redux/syllabusthunk";
import { generateLessonPlan } from "./generateLessonPlan";
import userStore from "../../../../zustand/userStore";
import Popup from "../../../EventOrganiser/Popup";
import { setStepIndex, setStepValid, stopTour , startTour} from "../../../../redux/globalJoyrideSlice";
import { myProjectsTourSteps } from "../../../../tour/teacherPlanerTourSteps";
const MyHomeworks = ({ teacherId }) => {
  const dispatch = useDispatch();
  const {
    data: homeworks,
    loading,
    error,
  } = useSelector((state) => state.homeworks);
  const { syllabusData } = useSelector((state) => state.syllabus);
  const { teacherPeriods } = useSelector((state) => state.myTimetable);
  const { sessions } = useSelector((state) => state.academicCalendar);

  const [weeklyPlan, setWeeklyPlan] = useState([]);
  const [formData, setFormData] = useState({
    selectedClass: "",
    selectedSection: "",
  });
  const [expanded, setExpanded] = useState(false);
  const navigate=useNavigate();

  const formatText = (text) => {
    return text.split("\n").map((line, index) => (
      <React.Fragment key={index}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  const userData = userStore((state) => state.user);
  const teacher_id = userData?.teacher_id;
const { stepIndex, run } = useSelector(
  (state) => state.globalJoyride
);
  useEffect(() => {
    if (teacher_id) {
      dispatch(fetchMyHomeworks(teacher_id));
      dispatch(fetchTeacherTimetable(teacher_id));
      dispatch(fetchSessionsThunk());
      dispatch(getSyllabusThunk(teacher_id));
    }
  }, [dispatch, teacher_id]);
// useEffect(() => {
//     const LAST_STEP_INDEX = 4;
  
//     if (run && stepIndex === LAST_STEP_INDEX) {
//       // 1. Stop the tour FIRST
//       dispatch(stopTour());
      
//       // 2. Use a tiny timeout to let Joyride clean up its DOM references
//       setTimeout(() => {
//         navigate("/allHomeworks");
//       }, 50); 
//     }
//   }, [stepIndex, run, dispatch, navigate]);
  useEffect(() => {
    if (teacherPeriods?.classes?.length > 0) {
      setTimeout(() => {
        dispatch(setStepIndex(1));
      }, 0);
    }
  }, [teacherPeriods.classes]);

  useEffect(() => {
    if (
      !syllabusData.length ||
      !teacherPeriods.classes?.length ||
      !sessions.length
    )
      return;

    const { weeks } = generateLessonPlan({
      syllabusData,
      sessions,
      teacherPeriods,
      selectedClass: "",
      selectedSubject: "",
      selectedSection: "",
    });

    setWeeklyPlan(weeks);
  }, [syllabusData, teacherPeriods, sessions]);

  if (!userData?.teacher_id) {
    return (
      <Popup
        title="Access Restricted"
        height="300px"
        maxWidth="500px"
        onClose={() => window.history.back()}
        minHeight="200px"
      >
        <div className="text-center p-4">
          <h3 className="text-xl font-bold mb-3">
            ⚠️ Teacher Assignment Needed
          </h3>
          <p className="mb-4">
            You are not yet assigned as a teacher. Please contact the
            administrator to get a teacher ID before viewing your timetable.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </Popup>
    );
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const findHomework = (row) => {
    const chapterRows = weeklyPlan
      .flat()
      .filter(
        (r) =>
          String(r.class_id) === String(row.class_id) &&
          String(r.period?.section_id) === String(row.period?.section_id) &&
          String(r.period?.subject_id) === String(row.period?.subject_id) &&
          r.chapter.trim().toLowerCase() === row.chapter.trim().toLowerCase()
      )
      .sort((a, b) => new Date(a.period.date) - new Date(b.period.date));

    const hw = homeworks?.find(
      (hwItem) =>
        String(hwItem.class_id) === String(row.class_id) &&
        String(hwItem.section_id) === String(row.period?.section_id) &&
        String(hwItem.subject_id) === String(row.period?.subject_id) &&
        hwItem.chapter_name.trim().toLowerCase() ===
          row.chapter.trim().toLowerCase() &&
        String(hwItem.period_number) === String(row.sno)
    );

    if (!hw) return null;

    const matchedRow = chapterRows.find(
      (r) => String(r.sno) === String(hw.period_number)
    );

    return matchedRow ? { ...hw, date: matchedRow.period.date } : null;
  };

  const allRows = weeklyPlan.flat();

  // ✅ Apply class & section filter
  const filteredRows = allRows
    .map((row) => {
      const hw = findHomework(row);
      return hw ? { row, hw } : null;
    })
    .filter(Boolean)
    .filter(({ hw }) => {
      if (formData.selectedClass && hw.class_id !== formData.selectedClass)
        return false;
      if (
        formData.selectedSection &&
        hw.section_id !== formData.selectedSection
      )
        return false;
      return true;
    });

  return (
    <div style={{ maxWidth: 1300, margin: "auto" }}>
      {/* <Typography variant="h5" sx={{ p: 2 }}>
        📚 My Homeworks
      </Typography> */}

      {/* ✅ Filters */}
      <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
        <div>
          <label>Select Class</label>
          <select
          data-tour="homeworks-select-class"
            name="selectedClass"
            value={formData.selectedClass}
            onChange={(e)=>{
              handleChange(e)
              dispatch(setStepIndex(2))
            }}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">-- Select Class --</option>
            {teacherPeriods?.classes?.map((cls) => (
              <option key={cls.class_id} value={cls.class_id}>
                {cls.class_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Select Section</label>
          <select
          data-tour="homeworks-select-section"
            name="selectedSection"
            value={formData.selectedSection}
            onChange={(e)=>{
              handleChange(e)
              dispatch(setStepIndex(3))
            }}
            style={{ padding: "5px", marginLeft: "10px" }}
          >
            <option value="">-- Select Section --</option>
            {teacherPeriods?.classes
              ?.find((cls) => cls.class_id == formData.selectedClass)
              ?.sections?.map((sec) => (
                <option key={sec.section_id} value={sec.section_id}>
                  {sec.section_name}
                </option>
              ))}
          </select>
        </div>
      </div>

      <TableContainer 
      data-tour="homeworks-table"
      component={Paper} sx={{ width: "100%", boxShadow: 3 }}>
        {loading && <CircularProgress sx={{ m: 2 }} />}
        {error && <Typography color="error">{error}</Typography>}

        {!loading && !error && (
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                <TableCell>Date</TableCell>
                <TableCell>Day</TableCell>
                <TableCell>Class</TableCell>
                <TableCell>Section</TableCell>
                <TableCell>Subject</TableCell>
                <TableCell>Chapter</TableCell>
                <TableCell>Period</TableCell>
                <TableCell>Homework Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map(({ row, hw }, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {moment(hw.date).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{moment(hw.date).format("dddd")}</TableCell>
                    <TableCell>{hw.class_name}</TableCell>
                    <TableCell>{hw.section_name}</TableCell>
                    <TableCell>{hw.subject_name}</TableCell>
                    <TableCell>{hw.chapter_name}</TableCell>
                    <TableCell>{hw.period_number}</TableCell>
                    {/* <TableCell>{hw.homework_details}</TableCell> */}
                    <TableCell>
                      {expanded
                        ? formatText(hw.homework_details)
                        : formatText(hw.homework_details.slice(0, 30))}

                      {hw.homework_details.length > 30 && (
                        <span
                          style={{
                            color: "blue",
                            cursor: "pointer",
                            marginLeft: "5px",
                          }}
                          onClick={() => setExpanded(!expanded)}
                        >
                          {expanded ? "View Less" : "View More"}
                        </span>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
    </div>
  );
};

export default MyHomeworks;
